import { useQuery } from "@apollo/client";
import { loader } from "graphql.macro";
import React, { useState } from "react";
import Autocomplete from "react-autocomplete";
import { Link, withRouter } from "react-router-dom";
import useDebounce from "../util/debounce";

const GET_RECIPES = loader("../queries/search.graphql");

function Search(props) {
	const [searchText, setSearchText] = useState("");

	const onSelect = (item) => {
		props.history.push(`/recipe/${item.id}`);
	};

	const term = useDebounce(searchText, 200);

	const { loading, data } = useQuery(GET_RECIPES, {
		variables: { query: term },
		skip: !term,
	});

	const hits = data?.search?.hits?.map((el) => el._source) || [];

	return (
		<>
			<div
				className={`control has-icons-left has-icons-right ${
					loading ? "is-loading" : ""
				}`}>
				<Autocomplete
					inputProps={{
						className: "input",
						placeholder: "Search recipes",
						//onKeyUp: (e) => search(e),
					}}
					wrapperStyle={{ display: "block" }}
					getItemValue={(item) => item.title}
					items={hits}
					renderItem={(item, highlighted) => (
						<Link
							className={`dropdown-item ${highlighted ? "is-active" : ""}`}
							key={item.id}
							to={`/recipe/${item.id}`}>
							{item.title}
						</Link>
					)}
					value={searchText}
					onChange={(e) => setSearchText(e.target.value)}
					onSelect={(title, item) => onSelect(item)}
				/>
				<span className="icon is-left">
					<i className="fas	fa-search" aria-hidden="true"></i>
				</span>
			</div>
		</>
	);
}

export default withRouter(Search);
